<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-links-learning.svg" can-back-flag="1" v-if="isGeo"></Header>
      <Header title-image="static/images/common/logo-links.svg" can-back-flag="1" v-else></Header>
    </header>

    <!--一覧-->
    <div id="wrapper">
      <div class="content">

        <!--地理の場合-->
        <div class="geo-links-list-box" v-show="isGeo">
          <ul>
            <li v-for='row in rows' v-bind:key='row.id'>
              <h3 class="ttl" v-if="row.category != ''">{{ row.category }}</h3>
              <a :href='row.url' target="_blank" rel="noopener">{{ row.title }}</a>
              <p>{{ row.subtitle }}</p>
            </li>
          </ul>
        </div>

        <!--歴史の場合-->
        <div class="his-links-list-box" v-show="isHistory">
          <ul>
            <li v-for='row in rows' v-bind:key='row.id'>
              <h3 class="ttl" v-if="row.category != ''">{{ row.category }}</h3>
              <a :href='row.url' target="_blank" rel="noopener">{{ row.title }}</a>
              <p><span v-if="row.country">{{ row.country }}<br></span>{{ row.subtitle }}</p>
            </li>
          </ul>
        </div>

        <!--公共の場合-->
        <div class="links-list-box" v-show="isCivics">
          <ul>
            <li v-for='row in rows' v-bind:key='row.id'>
              <dl>
                <dt><img :src="row.logo" alt=""></dt>
                <dd>
                  <a :href='row.url' target="_blank" rel="noopener">{{ row.title }}</a>
                  <p>{{ row.subtitle }}</p>
                </dd>
              </dl>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  mounted: function () {

    $("body").removeClass()
    $("body").addClass("page-low")
    if (this.isHistory) {
      $("body").addClass("cat-his-links")
      $("body").addClass("page-his-links-index")
    } else {
      $("body").addClass("cat-links")
      $("body").addClass("page-links-index")
    }
    cmd.adjustStyle()

    this.search()
  },
  methods: {
    ...mapActions('LinkModule', {
      'prevAction': 'prevAction',
      'search': 'search',
    })

  },
  computed: {
    ...mapGetters('LinkModule', [
      'rows',
    ]),
    ...mapGetters('MenuModule', [
      'isGeo',
      'isHistory',
      'isCivics',
    ])
  },
  components: {
    Header
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LinkList.vue